import { CharlieButton } from '@ver.id/libs.ui.charlie';

type FlowFooterProps = {
  primaryLabel?: string;
  onPrimary?: () => void;
  secondaryLabel: string;
  onSecondary: () => void;
};

/**
 * FlowFooter — Primary + outline button pair for flow actions.
 *
 * Pure presentational. Positioning is handled by the layout:
 * - MobileLayout renders this in a sticky footer slot outside the scroll area.
 * - DesktopLayout renders this inline in the content flow (passed via page footer prop).
 */
export default function FlowFooter({
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
}: FlowFooterProps) {
  return (
    <div className="flex flex-col items-center gap-3">
      {primaryLabel && onPrimary && (
        <CharlieButton pill block onClick={onPrimary}>
          {primaryLabel}
        </CharlieButton>
      )}
      <CharlieButton variant="outline" pill block onClick={onSecondary}>
        {secondaryLabel}
      </CharlieButton>
    </div>
  );
}
